import React, { useEffect, useRef } from "react";

const ContactFormSection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle("active", entry.isIntersecting);
        });
      },
      { threshold: 0.2 }
    );

    const section = sectionRef.current;
    if (section) observer.observe(section);

    return () => {
      if (section) observer.unobserve(section);
    };
  }, []);

  return (
    <section className="hp-gif-section hp-reveal" ref={sectionRef}>
      <img
        src="/Image/main-gif.gif"
        alt="Kuku Namkeen product showcase"
        className="hp-gif-section__image"
      />
    </section>
  );
};

export default ContactFormSection;
